import { get } from '@/apis/client';
import { Taxonomy } from '@/app/types';

export const getAllTaxonomies = async (): Promise<Taxonomy[]> => {
  try {
    const data = await get('taxonomies');
    if (data && data.error !== true && Array.isArray(data.results)) {
      return data.results;
    } else {
      throw new Error(`getAllTaxonomies API Error: ${data?.message || 'Unknown error'}`);
    }
  } catch (error) {
    console.error('Error fetching taxonomy data:', error);
    throw error;
  }
};

export const getTaxonomyBySlug = async (slug: string): Promise<Taxonomy | null> => {

  const data = await get(`taxonomies/${slug}`);
  if (!data) {
    throw new Error('getTaxonomyBySlug: received null or undefined response');
  }
  if (data.error) {
    console.warn(`getTaxonomyBySlug API Warning: ${data.message || 'Unknown warning'}`);
    return null;
  }
  return data.results[0];
};

export const getTaxonomyTag = async (taxonomyTag: string) => {
  try {
    const data = await get(`taxonomies/${taxonomyTag}`);
    return data;
  } catch (error) {
    console.error(`Failed to GET content ${taxonomyTag} from /taxonomies`, error);
    throw error;
  }
};
